import React from 'react'
import { Button } from '@/components/ui/button'

interface EmptyStateProps {
  projectName: string
}

export const EmptyState = ({ projectName }: EmptyStateProps) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 border rounded-lg bg-white dark:bg-gray-800 shadow-sm mt-8 h-[80vh] relative overflow-hidden">
      {/* Interview rain animation */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        {[
          { left: '10%', delay: '0s', char: '?' },
          { left: '25%', delay: '0.5s', char: '!' },
          { left: '40%', delay: '1s', char: '?' },
          { left: '55%', delay: '1.5s', char: '!' },
          { left: '70%', delay: '2s', char: '?' },
          { left: '85%', delay: '2.5s', char: '!' },
        ].map((drop, idx) => (
          <span
            key={idx}
            className="question-rain-drop"
            style={{ left: drop.left, animationDelay: drop.delay, fontSize: '3rem' }}
          >
            {drop.char}
          </span>
        ))}
      </div>

      {/* Interview icon */}
      <div className="w-16 h-16 bg-gray-100 dark:bg-gray-700 rounded-full flex items-center justify-center mb-6 relative z-10">
        <svg className="w-8 h-8 text-[#FF4A8E]" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M8 9H16M8 13H14M8 17H11M19 4H5C3.89543 4 3 4.89543 3 6V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V6C21 4.89543 20.1046 4 19 4Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>

      <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2 relative z-10">
        No interview insights yet
      </h3>
      <p className="text-gray-500 dark:text-gray-400 text-center max-w-md mb-6 relative z-10">
        Add meetings to {projectName} and let Evermuse analyze them to generate interview insights and key takeaways.
      </p>

      {/* <div className="flex flex-col gap-4 relative z-10">
        <Button
          onClick={() => (window.location.href = '/dashboard/meetings')}
          className="bg-[#FF4A8E] hover:bg-[#ff2c7d] text-white"
        >
          Go to Meetings
        </Button>
      </div> */}
    </div>
  )
}
